var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavCompo'),_c('router-view'),_c('FooterCompo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }